/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { OrganizationDto } from '../models/organization-dto';
import { organizationsAllGet$Json } from '../fn/organizations/organizations-all-get-json';
import { OrganizationsAllGet$Json$Params } from '../fn/organizations/organizations-all-get-json';
import { organizationsAllGet$Plain } from '../fn/organizations/organizations-all-get-plain';
import { OrganizationsAllGet$Plain$Params } from '../fn/organizations/organizations-all-get-plain';
import { organizationsOrganizationIdDelete } from '../fn/organizations/organizations-organization-id-delete';
import { OrganizationsOrganizationIdDelete$Params } from '../fn/organizations/organizations-organization-id-delete';
import { organizationsOrganizationIdGet$Json } from '../fn/organizations/organizations-organization-id-get-json';
import { OrganizationsOrganizationIdGet$Json$Params } from '../fn/organizations/organizations-organization-id-get-json';
import { organizationsOrganizationIdGet$Plain } from '../fn/organizations/organizations-organization-id-get-plain';
import { OrganizationsOrganizationIdGet$Plain$Params } from '../fn/organizations/organizations-organization-id-get-plain';
import { organizationsOrganizationIdPut$Json } from '../fn/organizations/organizations-organization-id-put-json';
import { OrganizationsOrganizationIdPut$Json$Params } from '../fn/organizations/organizations-organization-id-put-json';
import { organizationsOrganizationIdPut$Plain } from '../fn/organizations/organizations-organization-id-put-plain';
import { OrganizationsOrganizationIdPut$Plain$Params } from '../fn/organizations/organizations-organization-id-put-plain';
import { organizationsOwnerGet$Json } from '../fn/organizations/organizations-owner-get-json';
import { OrganizationsOwnerGet$Json$Params } from '../fn/organizations/organizations-owner-get-json';
import { organizationsOwnerGet$Plain } from '../fn/organizations/organizations-owner-get-plain';
import { OrganizationsOwnerGet$Plain$Params } from '../fn/organizations/organizations-owner-get-plain';
import { organizationsPost$Json } from '../fn/organizations/organizations-post-json';
import { OrganizationsPost$Json$Params } from '../fn/organizations/organizations-post-json';
import { organizationsPost$Plain } from '../fn/organizations/organizations-post-plain';
import { OrganizationsPost$Plain$Params } from '../fn/organizations/organizations-post-plain';

@Injectable({ providedIn: 'root' })
export class OrganizationsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `organizationsPost()` */
  static readonly OrganizationsPostPath = '/organizations';

  /**
   * Create organization.
   *
   * Creates a new organization and sets the current user as owner.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationsPost$Plain$Response(params?: OrganizationsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationDto>> {
    const obs = organizationsPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create organization.
   *
   * Creates a new organization and sets the current user as owner.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationsPost$Plain(params?: OrganizationsPost$Plain$Params, context?: HttpContext): Observable<OrganizationDto> {
    const resp = this.organizationsPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrganizationDto>): OrganizationDto => r.body)
    );
  }

  /**
   * Create organization.
   *
   * Creates a new organization and sets the current user as owner.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationsPost$Json$Response(params?: OrganizationsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationDto>> {
    const obs = organizationsPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create organization.
   *
   * Creates a new organization and sets the current user as owner.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationsPost$Json(params?: OrganizationsPost$Json$Params, context?: HttpContext): Observable<OrganizationDto> {
    const resp = this.organizationsPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrganizationDto>): OrganizationDto => r.body)
    );
  }

  /** Path part for operation `organizationsOwnerGet()` */
  static readonly OrganizationsOwnerGetPath = '/organizations/owner';

  /**
   * Get organizations that user own.
   *
   * Returns details of all organizations that user own.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsOwnerGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsOwnerGet$Plain$Response(params?: OrganizationsOwnerGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrganizationDto>>> {
    const obs = organizationsOwnerGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get organizations that user own.
   *
   * Returns details of all organizations that user own.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsOwnerGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsOwnerGet$Plain(params?: OrganizationsOwnerGet$Plain$Params, context?: HttpContext): Observable<Array<OrganizationDto>> {
    const resp = this.organizationsOwnerGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<OrganizationDto>>): Array<OrganizationDto> => r.body)
    );
  }

  /**
   * Get organizations that user own.
   *
   * Returns details of all organizations that user own.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsOwnerGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsOwnerGet$Json$Response(params?: OrganizationsOwnerGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrganizationDto>>> {
    const obs = organizationsOwnerGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get organizations that user own.
   *
   * Returns details of all organizations that user own.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsOwnerGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsOwnerGet$Json(params?: OrganizationsOwnerGet$Json$Params, context?: HttpContext): Observable<Array<OrganizationDto>> {
    const resp = this.organizationsOwnerGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<OrganizationDto>>): Array<OrganizationDto> => r.body)
    );
  }

  /** Path part for operation `organizationsAllGet()` */
  static readonly OrganizationsAllGetPath = '/organizations/all';

  /**
   * Get organizations for user.
   *
   * Returns details of all organizations for user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsAllGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsAllGet$Plain$Response(params?: OrganizationsAllGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrganizationDto>>> {
    const obs = organizationsAllGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get organizations for user.
   *
   * Returns details of all organizations for user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsAllGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsAllGet$Plain(params?: OrganizationsAllGet$Plain$Params, context?: HttpContext): Observable<Array<OrganizationDto>> {
    const resp = this.organizationsAllGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<OrganizationDto>>): Array<OrganizationDto> => r.body)
    );
  }

  /**
   * Get organizations for user.
   *
   * Returns details of all organizations for user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsAllGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsAllGet$Json$Response(params?: OrganizationsAllGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrganizationDto>>> {
    const obs = organizationsAllGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get organizations for user.
   *
   * Returns details of all organizations for user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsAllGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsAllGet$Json(params?: OrganizationsAllGet$Json$Params, context?: HttpContext): Observable<Array<OrganizationDto>> {
    const resp = this.organizationsAllGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<OrganizationDto>>): Array<OrganizationDto> => r.body)
    );
  }

  /** Path part for operation `organizationsOrganizationIdGet()` */
  static readonly OrganizationsOrganizationIdGetPath = '/organizations/{organizationId}';

  /**
   * Get organization.
   *
   * Returns details of a specific organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsOrganizationIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsOrganizationIdGet$Plain$Response(params: OrganizationsOrganizationIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationDto>> {
    const obs = organizationsOrganizationIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get organization.
   *
   * Returns details of a specific organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsOrganizationIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsOrganizationIdGet$Plain(params: OrganizationsOrganizationIdGet$Plain$Params, context?: HttpContext): Observable<OrganizationDto> {
    const resp = this.organizationsOrganizationIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrganizationDto>): OrganizationDto => r.body)
    );
  }

  /**
   * Get organization.
   *
   * Returns details of a specific organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsOrganizationIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsOrganizationIdGet$Json$Response(params: OrganizationsOrganizationIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationDto>> {
    const obs = organizationsOrganizationIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get organization.
   *
   * Returns details of a specific organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsOrganizationIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsOrganizationIdGet$Json(params: OrganizationsOrganizationIdGet$Json$Params, context?: HttpContext): Observable<OrganizationDto> {
    const resp = this.organizationsOrganizationIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrganizationDto>): OrganizationDto => r.body)
    );
  }

  /** Path part for operation `organizationsOrganizationIdPut()` */
  static readonly OrganizationsOrganizationIdPutPath = '/organizations/{organizationId}';

  /**
   * Update organization.
   *
   * Updates name and other settings. Requires ManageOrganization permission.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsOrganizationIdPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationsOrganizationIdPut$Plain$Response(params: OrganizationsOrganizationIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationDto>> {
    const obs = organizationsOrganizationIdPut$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update organization.
   *
   * Updates name and other settings. Requires ManageOrganization permission.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsOrganizationIdPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationsOrganizationIdPut$Plain(params: OrganizationsOrganizationIdPut$Plain$Params, context?: HttpContext): Observable<OrganizationDto> {
    const resp = this.organizationsOrganizationIdPut$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrganizationDto>): OrganizationDto => r.body)
    );
  }

  /**
   * Update organization.
   *
   * Updates name and other settings. Requires ManageOrganization permission.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsOrganizationIdPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationsOrganizationIdPut$Json$Response(params: OrganizationsOrganizationIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationDto>> {
    const obs = organizationsOrganizationIdPut$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update organization.
   *
   * Updates name and other settings. Requires ManageOrganization permission.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsOrganizationIdPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  organizationsOrganizationIdPut$Json(params: OrganizationsOrganizationIdPut$Json$Params, context?: HttpContext): Observable<OrganizationDto> {
    const resp = this.organizationsOrganizationIdPut$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OrganizationDto>): OrganizationDto => r.body)
    );
  }

  /** Path part for operation `organizationsOrganizationIdDelete()` */
  static readonly OrganizationsOrganizationIdDeletePath = '/organizations/{organizationId}';

  /**
   * Delete organization.
   *
   * Soft-deletes the organization. Requires owner/admin.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationsOrganizationIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsOrganizationIdDelete$Response(params: OrganizationsOrganizationIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = organizationsOrganizationIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete organization.
   *
   * Soft-deletes the organization. Requires owner/admin.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationsOrganizationIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationsOrganizationIdDelete(params: OrganizationsOrganizationIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.organizationsOrganizationIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
